import {
    ApiUtils,
    _axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
    list: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/videoes/list", params, successCallback, failCallback, exceptionCallback);
    },
    save: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/edu/videoes/save", params, successCallback, failCallback, exceptionCallback);
    },
    toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/edu/videoes/toUpdate", params, successCallback, failCallback, exceptionCallback);
    },
    update: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.putLoadingAjax(constant.serverUrl + "/edu/videoes/update", params, successCallback, failCallback, exceptionCallback);
    },
    remove: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.deleteLoadingAjax(constant.serverUrl + "/edu/videoes/remove", params, successCallback, failCallback, exceptionCallback);
    },downCodes:(data, params, headers) => {

        ApiUtils.sendDownFile(
            constant.serverUrl + "/edu/videoes/downloadCodes",
            "get",
            data,
            params,
            headers
          );
    },updtSorts: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.putLoadingAjax(constant.serverUrl + "/edu/videoes/updtSorts", params, successCallback, failCallback, exceptionCallback);
    },
}
 
export default api;